import { Component, OnInit } from '@angular/core';
import { Faculty } from 'src/app/models/faculty.model';
import { FacultyService } from 'src/app/services/faculty/faculty.service';

@Component({
  selector: 'app-sanskrit',
  templateUrl: './sanskrit.component.html',
  styleUrls: ['./sanskrit.component.scss']
})
export class SanskritComponent implements OnInit {
  sanskirt:Faculty[];
  constructor(private facultyService:FacultyService) { }

  ngOnInit(): void {
    this.sanskirt=this.facultyService.getSanskrit();
  }

}
